module.exports = __webpack_public_path__ + "static/media/profile-pic.2f567136.svg";